import { Injectable } from '@angular/core'
import { UiStorageService } from './ui-storage.service'

@Injectable({
  providedIn: 'root',
})
export class KeyValueUiStorageService {
  private readonly usersKeyValuePrefix: Promise<string>

  constructor(private readonly storage: UiStorageService) {
    const base32User = storage.getBase32User()
    const clientId = storage.getClientId()
    this.usersKeyValuePrefix = Promise.all<string, number>([
      base32User,
      clientId,
    ]).then(
      userAndClient => `key-value/${userAndClient[1]}/${userAndClient[0]}`,
    )
  }

  async getValue<T>(key: string): Promise<T | undefined> {
    const prefix = await this.getPrefixForKey(key)
    return this.storage.getObject(prefix, true)
  }

  async setValue(key: string, value: unknown): Promise<void> {
    const prefix = await this.getPrefixForKey(key)
    return this.storage.putObject(prefix, value)
  }

  private getPrefixForKey(key: string): Promise<string> {
    return this.usersKeyValuePrefix.then(prefix => `${prefix}/${key}`)
  }
}
